// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__XYqvC","file":"styles_file__L7UEe"};